/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RollbackElectronMapperItem } from './RollbackElectronMapperItem';
import {
    RollbackElectronMapperItemFromJSON,
    RollbackElectronMapperItemFromJSONTyped,
    RollbackElectronMapperItemToJSON,
    RollbackElectronMapperItemToJSONTyped,
} from './RollbackElectronMapperItem';

/**
 * 
 * @export
 * @interface RollbackOverwolfElectronDataMappersResponse
 */
export interface RollbackOverwolfElectronDataMappersResponse {
    /**
     * 
     * @type {boolean}
     * @memberof RollbackOverwolfElectronDataMappersResponse
     */
    dryRun: boolean;
    /**
     * Number of OVERWOLF_ELECTRON mappers deactivated
     * @type {number}
     * @memberof RollbackOverwolfElectronDataMappersResponse
     */
    deactivatedCount: number;
    /**
     * 
     * @type {Array<RollbackElectronMapperItem>}
     * @memberof RollbackOverwolfElectronDataMappersResponse
     */
    deactivatedMappers?: Array<RollbackElectronMapperItem>;
}

/**
 * Check if a given object implements the RollbackOverwolfElectronDataMappersResponse interface.
 */
export function instanceOfRollbackOverwolfElectronDataMappersResponse(value: object): value is RollbackOverwolfElectronDataMappersResponse {
    if (!('dryRun' in value) || value['dryRun'] === undefined) return false;
    if (!('deactivatedCount' in value) || value['deactivatedCount'] === undefined) return false;
    return true;
}

export function RollbackOverwolfElectronDataMappersResponseFromJSON(json: any): RollbackOverwolfElectronDataMappersResponse {
    return RollbackOverwolfElectronDataMappersResponseFromJSONTyped(json, false);
}

export function RollbackOverwolfElectronDataMappersResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): RollbackOverwolfElectronDataMappersResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'dryRun': json['dryRun'],
        'deactivatedCount': json['deactivatedCount'],
        'deactivatedMappers': json['deactivatedMappers'] == null ? undefined : ((json['deactivatedMappers'] as Array<any>).map(RollbackElectronMapperItemFromJSON)),
    };
}

export function RollbackOverwolfElectronDataMappersResponseToJSON(json: any): RollbackOverwolfElectronDataMappersResponse {
    return RollbackOverwolfElectronDataMappersResponseToJSONTyped(json, false);
}

export function RollbackOverwolfElectronDataMappersResponseToJSONTyped(value?: RollbackOverwolfElectronDataMappersResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'dryRun': value['dryRun'],
        'deactivatedCount': value['deactivatedCount'],
        'deactivatedMappers': value['deactivatedMappers'] == null ? undefined : ((value['deactivatedMappers'] as Array<any>).map(RollbackElectronMapperItemToJSON)),
    };
}

